import React from 'react'

const Copyright = () => {
  return (
    <div className='w-full h-[30px] bg-[#0b1825]  text-gray-500 text-center'>
      <p>&#169; 2022 Designed and Developed by Arpit Jha</p>
    </div>
  )
}

export default Copyright
